
import { Row, Col, Card, Typography, Spin, List, Table, Tag, Space, Collapse, Tabs, PageHeader } from "antd";
import { Skeleton, Switch, Avatar } from 'antd';
import Slider from 'react-slick';
import "../Pages/desktop.css";
import React, { useEffect, useState } from "react";
import { EditOutlined, EllipsisOutlined, SettingOutlined, TrophyOutlined, TrophyFilled, TrophyTwoTone } from '@ant-design/icons';
import { useHistory, useParams } from "react-router";
import moment from "moment";
const { Meta } = Card;
const { Text, Link, Title } = Typography;


// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

function callback(key) {
    console.log(key);
}


  const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.`;
  

const Countries = [
    {
        "Sri Lanka" : 'lka',
        "Bangladesh" : 'bgd',
        "South Africa" : 'zaf',
        "Oman" : 'omn',
        "New Zealand" : 'nzl',
        "Ireland" : 'irl',
        "Scotland" : 'sco',
        "Namibia" : 'nam',
        "Australia" : 'aus',
        "England" : 'eng',
        "Afghanistan" : 'afg',
        "India" : 'ind',
        "Pakistan" : 'pak',
        "West Indies" : 'wes',
        "Netherlands" : 'nld',
        "Papua New Guinea" : 'png',
        "B1" : 'Flag_of_None',
        "B2" : 'Flag_of_None',
        "A1" : 'Flag_of_None',
        "A2" : 'Flag_of_None',
    }
];
const style = { padding: '8px 0' };
const { Panel } = Collapse;
const { TabPane } = Tabs;
const MatchDetails = () => {
    const {id} = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [scorecard, setScorecard] = useState(null);
    const [complete, setComplete] = useState(null);
    const TodayDate = moment(new Date()).format("DD MMM YYYY, dddd");
   
    useEffect(() => {
        if(loading == true){
            
            fetch('https://api.arynews.tv/sports/apiTxt/scorecard.php?id='+id)
                    .then(response => response.json())
                    .then(data => {
                        setScorecard(data);
                        setLoading(false)
                        
            });
        
        }
        
    });

    const dataSource = [
        {
          key: '1',
          name: 'Mike',
          age: 32,
          address: '10 Downing Street',
        },
        {
          key: '2',
          name: 'John',
          age: 42,
          address: '10 Downing Street',
        },
      ];
      
      const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Run',
          dataIndex: 'run',
          key: 'run',
        },
        {
          title: 'Ball',
          dataIndex: 'ball',
          key: 'ball',
        },
        {
          title: 'Fours',
          dataIndex: 'fours',
          key: 'fours',
        },
        {
            title: 'Sixes',
            dataIndex: 'sixes',
            key: 'sixes',
        },
        {
            title: 'Strike Rate',
            dataIndex: 'strike_rate',
            key: 'strike_rate',
        },
        {
            title: 'Out By',
            dataIndex: 'out_by',
            key: 'out_by',
            
        }
      ];


      const bowlerColumns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Over',
          dataIndex: 'over',
          key: 'over',
        },
        {
          title: 'Maiden',
          dataIndex: 'maiden',
          key: 'maiden',
        },
        {
          title: 'Run',
          dataIndex: 'run',
          key: 'run',
        },
        {
            title: 'Wicket',
            dataIndex: 'wicket',
            key: 'wicket',
        },
        {
            title: 'Economy',
            dataIndex: 'economy',
            key: 'economy',
        },
      ];

      const fallColumns = [
        {
          title: 'Player',
          dataIndex: 'player',
          key: 'player',
        },
        {
          title: 'Score',
          dataIndex: 'score',
          key: 'score',
        },
        {
          title: 'Wicket',
          dataIndex: 'wicket',
          key: 'wicket',
        },
        {
          title: 'Over',
          dataIndex: 'over',
          key: 'over',
        }
      ];

      const partnerColumns = [
        {
          title: 'Player One',
          dataIndex: 'player_a',
          key: 'player_a',
        },
        {
          title: 'Player Two',
          dataIndex: 'player_b',
          key: 'player_b',
        },
        {
          title: 'Run',
          dataIndex: 'run',
          key: 'run',
        },
        {
          title: 'Ball',
          dataIndex: 'ball',
          key: 'ball',
        }
      ];
    return(
        <>
            <PageHeader
                className="site-page-header"
                onBack={() => history.push('/fixvert/12')}
                title={scorecard != null ? scorecard.data.scorecard[1].team.name + ' VS ' + scorecard.data.scorecard[2].team.name : 'Loading'}
                subTitle={scorecard != null ? scorecard.data.result.replace('wkts', 'wickets') : "Loading..."}
            />
            {loading == false ? 

                <>
                <Card 
                    size="small" 
                    title={scorecard.data.scorecard[1].team.name + ' VS ' + scorecard.data.scorecard[2].team.name }>
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={12}>
                                <center>
                                    <Avatar src={'https://api.arynews.tv/sports/svg/'+Countries[0][scorecard.data.scorecard[1].team.name]+'.svg'} />
                                    <Title level={5}>{scorecard.data.result.includes(scorecard.data.scorecard[1].team.name) ? (<span>{scorecard.data.scorecard[1].team.name} <TrophyTwoTone twoToneColor="#52c41a" /></span>)  : scorecard.data.scorecard[1].team.name } </Title>
                                    <span className="score">{scorecard.data.scorecard[1].team.score} / {scorecard.data.scorecard[1].team.wicket} ({ scorecard.data.scorecard[1].team.over })</span>
                                </center>
                            </Col>
                            <Col className="gutter-row" span={12}>
                            <center>
                                    <Avatar src={'https://api.arynews.tv/sports/svg/'+Countries[0][scorecard.data.scorecard[2].team.name]+'.svg'} />
                                    <Title level={5}>{scorecard.data.result.includes(scorecard.data.scorecard[2].team.name) ? (<span>{scorecard.data.scorecard[2].team.name} <TrophyTwoTone twoToneColor="#52c41a"/></span>) : scorecard.data.scorecard[2].team.name}</Title>
                                    <span className="score">{scorecard.data.scorecard[2].team.score} / {scorecard.data.scorecard[2].team.wicket} ({ scorecard.data.scorecard[2].team.over })</span>
                                </center>
                            </Col>
                        </Row>
                        <center style={{ paddingTop:20 }}><Title className="resultDetailMatch" level={3}>{scorecard.data.result.replace('wkts', 'wickets')}</Title></center>
                        
                        
                        
                </Card>

                <Collapse defaultActiveKey={[scorecard.data.result.includes(scorecard.data.scorecard[2].team.name) ? 2 : 1]} onChange={callback} ghost={true}>
                            <Panel header={scorecard.data.result.includes(scorecard.data.scorecard[1].team.name) ? (<span>{scorecard.data.scorecard[1].team.name} <TrophyTwoTone twoToneColor="#52c41a" /></span>)  : scorecard.data.scorecard[1].team.name  + ' Inning'} key="1">
                                <Tabs defaultActiveKey="1" onChange={callback} size="small">
                                    <TabPane tab="Batsman" key="1">
                                        <Table bordered={true} size="small" dataSource={scorecard.data.scorecard[1].batsman} columns={columns} />
                                    </TabPane>
                                    <TabPane tab="Bowling" key="2">
                                        <Table size="small" dataSource={scorecard.data.scorecard[1].bolwer} columns={bowlerColumns} />   
                                    </TabPane>
                                    <TabPane tab="Fall of wicket" key="3">
                                        <Table size="small" dataSource={scorecard.data.scorecard[1].fallwicket} columns={fallColumns} /> 
                                    </TabPane>
                                    <TabPane tab="Partnership" key="4">
                                        <Table size="small" dataSource={scorecard.data.scorecard[1].partnership} columns={partnerColumns} /> 
                                    </TabPane>
                                </Tabs>
                                <div className="extrasRuns">Extra Runs: {scorecard.data.scorecard[1].team.extras}</div>
                            </Panel>
                            <Panel header={scorecard.data.result.includes(scorecard.data.scorecard[2].team.name) ? (<span>{scorecard.data.scorecard[2].team.name} <TrophyTwoTone twoToneColor="#52c41a" /></span>)  : scorecard.data.scorecard[2].team.name + ' Inning'} key="2">
                               
                                <Tabs defaultActiveKey="1" onChange={callback}>
                                    <TabPane tab="Batsman" key="1">
                                        <Table size="small" dataSource={scorecard.data.scorecard[2].batsman} columns={columns} />
                                    </TabPane>
                                    <TabPane tab="Bowling" key="2">
                                        <Table size="small" dataSource={scorecard.data.scorecard[2].bolwer} columns={bowlerColumns} />  
                                    </TabPane>
                                    <TabPane tab="Fall of wicket" key="3">
                                        <Table size="small" dataSource={scorecard.data.scorecard[2].fallwicket} columns={fallColumns} /> 
                                    </TabPane>
                                    <TabPane tab="Partnership" key="4">
                                        <Table size="small" dataSource={scorecard.data.scorecard[2].partnership} columns={partnerColumns} /> 
                                    </TabPane>
                                </Tabs>
                                <div className="extrasRuns">Extra Runs: {scorecard.data.scorecard[2].team.extras}</div>
                            </Panel>
                </Collapse>
                </>
            
            : 
            <div className="centLoading">
                <Spin size="large" />
            </div>}
            
        </>       
        
    );
}

export default MatchDetails;